export interface IFinalizedReport {
    summary: IReportSummary
    report: IReport
}

export enum ReportStatus {
    SUCCESS = 'Success',
    WARNING = 'Warning',
    ERROR = 'Error',
    UNKNOWN = 'Unknown',
}

export interface IReportSegment {
    details: string[]
    status: ReportStatus
}

export interface IReport {
    [key: string]: IReportSegment
}

export interface IReportSummary {
    status: ReportStatus
    [key: string]: any
}

export interface IFinalizedReport {
    summary: IReportSummary
    report: IReport
}
